import { useQuery, useLazyQuery } from "@apollo/react-hooks";
import React, { useState, useEffect, Fragment } from "react";
import moment from "moment";

import { DashboardV2D1 } from "./DashboardV2_D1";
import { DashboardV2D2 } from "./DashboardV2_D2";
import { DashboardV2D3 } from "./DashboardV2_D3";
import { DashboardV2D4 } from "./DashboardV2_D4";
import { DashboardV2D5 } from "./DashboardV2_D5";
import { DashboardV2D6 } from "./DashboardV2_D6";


export const DashboardV2 = () => {
    return (
        <Fragment>
            <DashboardV2D1 />
            <DashboardV2D2 />
            <DashboardV2D3 />
            <DashboardV2D4 />
            <DashboardV2D5 />
            <DashboardV2D6 />
        </Fragment>
    )
}